import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function MenuSetManage ( props ) {

    return <BasicCrudScreenType id="MenuSet" table="MenuSet" view="MenuSet" />;

}

export default MenuSetManage;
